<template>
  <v-layout
    wrap
    class="text-left pt-2"
    style="background-color:#CCC;padding: 10px;"
  >
    <v-flex xs9>
      {{getSelectedUsersText(this.selectedUsers)}}
    </v-flex>
    <v-flex xs3>
      <v-row justify="center">
        <v-dialog v-model="dialog" scrollable max-width="400px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{$t('commonMenus.assign')}}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              {{$t('users.title')}}
            </v-card-title>
            <v-divider />
            <center style="padding: 0 20px;">
              <v-text-field
                solo
                :label="$t('common.search')"
                append-icon="mdi-magnify"
                style="margin-top:30px;"
                v-model="search"
                @input="handleSearch"
              />
            </center>
            <v-divider />
            <v-card-text style="height: 400px;">
              <v-checkbox
                v-for="user in usersFiltered"
                :key="user.ID"
                v-model="selectedUsers"
                :label="user.Name"
                :value="user.ID" 
                multiple
              />
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-layout wrap>
                <v-flex class="text-right">
                  <v-btn @click="handleCancel">{{$t('common.cancel')}}</v-btn>
                  <v-btn dark :color="enterpriseColor" @click="handleSave">{{$t('common.save')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  export default {
    props: {
      menuID: {
        type: String,        
        require: true
      }
    },
    data: () => ({
      search: '',
      users: null,
      usersFiltered: null,
      selectedUsersBK: [],
      selectedUsers: [],
      loading: true,
      dialogm1: '',
      dialog: false,
    }),
    computed: {     
      ...mapState('app',['saving']), 
      bgColor () {
        return this.$store.state.app.BGColor
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      editTMP () {
        return this.$store.state.app.editTMP
      }
    },
    watch: {
      'editTMP.ID': {
        handler: function (newValue) {
          this.handleGetSelectedUsers()
        },
        deep: true
      }
    },
    mounted () {
      this.handleGetSelectedUsers()
      this.handleGetAllUsers()
    },
    methods: {
      getSelectedUsersText(value) {
        return this.users.filter(x => value.indexOf(x.ID) >= 0).map(item=>{
          return item.Name
        }).join(', ')
      },
      handleSearch () {
        if (this.search) this.usersFiltered = this.users.filter(x => x.Name.toUpperCase().indexOf(this.search.toUpperCase()) >= 0)
        else this.usersFiltered = this.users
      },
      handleGetSelectedUsers () {
        this.loading = true
        api.getAll(`menus/common/${this.menuID}/users`, true, 1, 100000, '').then(response => {
          this.selectedUsers = response.map(item => {
            return item.ID
          })
          this.selectedUsersBK = JSON.parse(JSON.stringify(this.selectedUsers))
          this.loading = false
        })
      },
      handleGetAllUsers () {
        this.loading = true
        api.getAll('users', true, 1, 100000, '').then(response => {
          this.users = response.data.map(item => {
            return ({
              ID: item.ID,
              Name: item.Name
            })
          })
          this.handleSearch()
          this.loading = false
        })
      },
      handleCancel() {
        this.selectedUsers = this.selectedUsersBK
        this.dialog = false
      },
      handleSave() {
        this.loading = true
        api.updateItem(`menus`,`/common/${this.menuID}/users`, this.selectedUsers).then(response => {
          this.selectedUsersBK = this.selectedUsers
          this.dialog = false
          this.loading = false
        })
        
      }
    }
  }
</script>

<style>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>
